export const handleSubmit = ({mutation: updateGraphicSet, history, graphicSetToEdit}) => values => {
    const updatedData = updateGraphicSet({
        variables: {
            graphicSetInput: {
                ...values,
                layouts:
                    values.layouts &&
                    values.layouts.map(layout => ({
                        ...layout,
                        id: undefined,
                        assetIdCategoryIds: undefined,
                        originalSize: undefined,
                        assetIdCodename: undefined,
                        format: undefined,
                        cron: "* * * *",
                        pos: {
                            x: parseFloat(layout.pos.x),
                            y: parseFloat(layout.pos.y),
                        },
                        size: {
                            x: parseFloat(layout.size.x),
                            y: parseFloat(layout.size.y),
                        },
                        seconds: parseInt(layout.seconds),
                        segments: layout.segments.map(segment => ({...segment, id: undefined})),
                    })),
                customerId: undefined,
            },
            customerId: graphicSetToEdit.customerId,
            graphicSetId: graphicSetToEdit.id,
        },
    });

    return updatedData
        .then(result => {
            const graphicSet = result.data.updateGraphicSet;
            if (graphicSet && graphicSet.id) {
                history.goBack();
                //history.push(`/graphicset/details/${graphicSet.id}/customerId/${graphicSet.customerId}`);
            }
        })
        .catch(console.error);
};
